/**
 * Utilidades matemáticas para redondeo y formateo de números
 */

export class MathUtils {
  
  /**
   * Redondea un número a 2 decimales usando redondeo en cascada
   * Primero redondea a 3 decimales, luego a 2 decimales
   * @param value - El número a redondear
   * @returns String con el número redondeado a 2 decimales
   */
  static toFixed2(value: any): string {
    const num = typeof value === 'string' ? parseFloat(value) : value;
    
    if (isNaN(num)) {
      return '0.00';
    }
    
    // Redondeo en cascada:
    // Paso 1: Redondear a 3 decimales
    const roundedTo3 = Math.round(num * 1000) / 1000;
    
    // Paso 2: Redondear a 2 decimales
    const roundedTo2 = Math.round(roundedTo3 * 100) / 100;
    
    return roundedTo2.toFixed(2);
  }
  
  /**
   * Método alternativo usando Math.round con factor de corrección
   */
  static toFixed2Alt(value: any): string {
    const num = typeof value === 'string' ? parseFloat(value) : value;
    
    if (isNaN(num)) {
      return '0.00';
    }
    
    // Usar factor de 100 para redondear a 2 decimales
    const factor = 100;
    const rounded = Math.round(num * factor) / factor;
    
    return rounded.toFixed(2);
  }
  
  /**
   * Redondeo usando biblioteca Decimal para mayor precisión
   */
  static toFixed2Precise(value: any): string {
    const num = typeof value === 'string' ? parseFloat(value) : value;
    
    if (isNaN(num)) {
      return '0.00';
    }
    
    // Multiplicar por 100, redondear, y dividir por 100
    // Usar parseFloat para evitar problemas de punto flotante
    const multiplied = parseFloat((num * 100).toFixed(10));
    const rounded = Math.round(multiplied);
    const result = rounded / 100;
    
    return result.toFixed(2);
  }
} 